<template>
  <span v-bind:class="{
    'p-2 badge badge-success':
      documentState.type === 'Approved',
    'p-2 badge badge-warning':
      documentState.type === 'Waiting',
    'p-2 badge badge-danger':
      documentState.type === 'Rejected',
  }">
    {{ getStateName(documentState.type) }}
    {{ documentState.type == "Waiting" ? documentState.state : "" }}
    ({{ documentState.lastname }} {{ documentState.firstname }})
  </span>
</template>
  
<script>
import workflowApi from "../../api/workflowApi";

export default {
  name: 'DocumentState',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },    
  data() {
    return {
      documentState: null,
    }
  },
  methods: {
    getStateName(state) {
      switch (state) {
        case "Waiting":
          return this.$t("pages.workflow.details.waiting");
        case "Approved":
          return this.$t("pages.workflow.details.approved");
        case "Rejected":
          return this.$t("pages.workflow.details.rejected");
        case "Start":
          return this.$t("pages.workflow.details.start");
        default:
          return this.$t("pages.workflow.details.cancelled");
      }
    },
  },
  created() {
    workflowApi.getDocumentCurrentState(this.id).then(({ data }) => {
      this.documentState = data[0];
    });
  },
};
</script>
  
  
  